import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


@Injectable()
export class changePasswordService {

    isShowing: boolean = false;
    modal = new Subject<boolean>();

    constructor(
         private http: HttpClient
        ) {
        this.modal.subscribe((value) => {
            this.isShowing = value;
        });
    }

    changePassword(obj) {
        return this.http.post(environment.serverUrl + '/user/changePassword', obj);
    }
    open() {
        this.modal.next(true);
    }
    close() {
        this.modal.next(false);
    }


}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.service.ts